export default __webpack_public_path__ + "static/media/imagem_09.9a2d1466.svg";